<template>
  <div class="tab-content__tabs global__fade-in-up" :id="id">
    <div class="dont-print" role="tablist" ref="tabs" @keydown="handleKeyDown">
      <slot name="tabs"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'tab-content__tabs-1',
    },
  },
  mounted() {
    this.tabIndex = 0
    this.tabs = Array.from(this.$refs.tabs.children)
    this.panels = this.$el.querySelectorAll('.tab-content__tabs__panel')
    var that = this
    this.tabs.forEach(function(tab) {
      tab.addEventListener('click', function(event) {
        // deselect previous tab and hide its panel, select new tab and show its panel
        that.$refs.tabs
          .querySelector('[aria-selected="true"]')
          .setAttribute('aria-selected', false)
        event.target.setAttribute('aria-selected', true)
        that.panels.forEach(function(panel) {
          panel.setAttribute('hidden', true)
        })
        // show panel
        document
          .getElementById(event.target.getAttribute('aria-controls'))
          .removeAttribute('hidden')
      })
    })
  },
  methods: {
    handleKeyDown(event) {
      // navigate tabs with left and right arrow keys
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        this.tabs[this.tabIndex].setAttribute('tabindex', -1)
        if (event.key === 'ArrowLeft') {
          if (--this.tabIndex < 0) {
            this.tabIndex = this.tabs.length - 1
          }
        } else if (event.key === 'ArrowRight') {
          if (++this.tabIndex >= this.tabs.length) {
            this.tabIndex = 0
          }
        }
        this.tabs[this.tabIndex].setAttribute('tabindex', 0)
        this.tabs[this.tabIndex].focus()
      }
    },
  },
}
</script>
